import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/redux/store';

const selectHomeState = (state: RootState) => state.home;

export const selectSliderData = createSelector(
  selectHomeState,
  (homeState) => homeState.sliderData
);

export const selectNavigationData = createSelector(
  selectHomeState,
  (homeState) =>
    homeState.navigationData
      // A slugless category would link to `/category/null`.
      ?.filter((item) => item.slug)
      .map((item) => {
        // if (!item.subcategories || item.subcategories.length === 0) {
        //   return {
        //     name: item.name,
        //     link: `/category/${item.slug}`
        //   };
        // }

        // return {
        //   name: item.name,
        //   subMenu: item.subcategories.map((subItem) => {
        //     return {
        //       name: subItem.name,
        //       link: `/subcategory/${subItem.slug}`
        //     };
        //   })
        // };

        return {
          name: item.name,
          link: `/category/${item.slug}`,
          // Same value as `link`, but stated explicitly: the nav's active state
          // is driven by `matchPath`, and a category that omits it would simply
          // never highlight.
          matchPath: `/category/${item.slug}`,
          subMenu: item.subcategories
            ?.filter((subItem) => subItem.slug)
            .map((subItem) => ({
              name: subItem.name,
              link: `/subcategory/${subItem.slug}`
            }))
        };
      })
);
